var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSimilarJobs } from '@/api';
import { Card, EmptySateIcon, JobCardSkeleton } from '@/components';
import { SortDropDown } from '@/components';
import { useJobDetails } from '@/hoc';
import { useQuery } from '@/hooks/use-query';
import { useCallback, useState } from 'react';
import { SimilarJobCard } from './similar-job-card';
export var SimilarJobFromOtherCompanies = function () {
    var jobId = useJobDetails().jobId;
    var _a = useState(), sortBy = _a[0], setSortBy = _a[1];
    var getSimilarJobsFormOtherCompanies = useCallback(function () {
        var params = {
            similar_type: 'other',
        };
        if (sortBy) {
            params.sort_by = sortBy;
        }
        return getSimilarJobs({
            jobId: jobId,
            params: params,
        });
    }, [jobId, sortBy]);
    var _b = useQuery({
        queryFn: getSimilarJobsFormOtherCompanies,
    }), similarJobs = _b.data, isLoading = _b.isLoading, refetch = _b.refetch, setData = _b.setData;
    var handleUpdateJobDetails = function (jobId, jobDetails) {
        setData(function (prevData) {
            if (!prevData)
                return null;
            return prevData.map(function (job) {
                if (job.jobId === jobId) {
                    return __assign(__assign({}, job), jobDetails);
                }
                return job;
            });
        });
    };
    return (_jsxs(Card, { title: 'Other Jobs', containerClassName: 'h-96 overflow-y-auto', children: [_jsx("div", { className: 'flex justify-end bg-cardBackground sticky -top-2 z-40', children: _jsx(SortDropDown, { showRecommended: false, showPostedDate: false, matchScoreAsRelevant: false, showRelevant: true, handleSortByDefault: function () { return setSortBy('recommended'); }, handleSortByDesignation: function () { return setSortBy('designation'); }, handleSortByMatchScore: function () { return setSortBy('match_score'); }, handleSortByPostedDate: function () { return setSortBy('posted_date'); } }) }), isLoading
                ? __spreadArray([], Array(5), true).map(function (_, index) { return _jsx(JobCardSkeleton, {}, index); })
                : (similarJobs === null || similarJobs === void 0 ? void 0 : similarJobs.length) === 0 && (_jsx("div", { className: 'w-full h-full flex flex-col justify-center text-vjwPrimary items-center gap-2 py-8 bg-cardBackground rounded-lg', children: _jsx(EmptySateIcon, { className: 'size-28' }) })), _jsx("div", { className: 'flex flex-wrap gap-2', children: similarJobs === null || similarJobs === void 0 ? void 0 : similarJobs.map(function (job) { return (_jsx(SimilarJobCard, { jobDetails: job, handleUpdateJobDetails: handleUpdateJobDetails, refetchJobs: refetch }, job.jobId)); }) })] }));
};
